import '../styles/main.scss';

// Import jQuery
import $ from 'jquery';

// NAJA
import naja from 'naja';

import '../../../node_modules/nette.ajax.js/nette.ajax.js';

// Components
import './components/oembed';
import './components/lazy-load';
import './components/menu';

// Nette Forms
import netteForms from 'nette-forms';

import onDomReady from './onDomReady';

import PhoneNumberParser from './components/phoneValidator';

window.Nette = netteForms;
netteForms.initOnLoad();

$(function () {
	$.nette.init();
});

// Naja init
naja.initialize();
const NAVIGATION_LOADER_KEY = 'front.navigationLoader';
let safeStorage = null;
try {
	safeStorage = window.sessionStorage;
} catch (error) {
	safeStorage = null;
}

const readNavigationLoaderFlag = () =>
	safeStorage ? safeStorage.getItem(NAVIGATION_LOADER_KEY) === '1' : false;

const writeNavigationLoaderFlag = () => {
	if (safeStorage) {
		safeStorage.setItem(NAVIGATION_LOADER_KEY, '1');
	}
};

const clearNavigationLoaderFlag = () => {
	if (safeStorage) {
		safeStorage.removeItem(NAVIGATION_LOADER_KEY);
	}
};

if (readNavigationLoaderFlag()) {
	document.body.classList.add('is-loading');
}

const finishNavigationLoading = () => {
	document.body.classList.remove('is-loading');
	clearNavigationLoaderFlag();
};

// LightBox
import GLightbox from 'glightbox';

window.GLightbox = new GLightbox({
	touchNavigation: true,
});

naja.addEventListener('start', () => {
	document.body.classList.add('is-loading');
});

naja.addEventListener('complete', () => {
	document.body.classList.remove('is-loading');
});

window.addEventListener('load', () => {
	finishNavigationLoading();
});

window.addEventListener('pageshow', () => {
	finishNavigationLoading();
});

document.addEventListener('submit', event => {
	if (
		event.target instanceof HTMLFormElement &&
		event.target.matches('form.search-form')
	) {
		if (event.target.dataset.loadingSubmitted === '1') {
			return;
		}

		event.preventDefault();
		event.target.dataset.loadingSubmitted = '1';
		writeNavigationLoaderFlag();
		document.body.classList.add('is-loading');
		window.requestAnimationFrame(() => {
			window.requestAnimationFrame(() => {
				HTMLFormElement.prototype.submit.call(event.target);
			});
		});
	}
});

let scrolledY = window.scrollY;
let parallax = document.querySelectorAll('.parallax');
parallax.forEach(function (el) {
	updateParallax(el, scrolledY);
});

document.addEventListener('scroll', function () {
	let scrolledY = window.scrollY;
	let parallax = document.querySelectorAll('.parallax');
	parallax.forEach(function (el) {
		updateParallax(el, scrolledY);
	});
});

function updateParallax(el, scrolledY) {
	let parallaxStart = el.offsetTop;
	let windowHeight = window.innerHeight;
	let img = el.querySelector('.parallax-img');

	if (scrolledY + windowHeight > parallaxStart) {
		let parallaxOffset = scrolledY - parallaxStart;
		img.style.transform = 'translateY(' + parallaxOffset * 0.5 + 'px)';
	}
}

const slideToElement = hash => {
	hash = hash.replace('#', '');
	const targetElement = document.getElementById(hash);
	const masthead = document.getElementById('master');

	console.log(hash);

	if (targetElement && masthead) {
		const mastheadHeight = masthead.clientHeight;
		const elementPosition =
			targetElement.getBoundingClientRect().top + window.scrollY;
		const offsetPosition = elementPosition - mastheadHeight;

		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth',
		});
	}
};

document.querySelectorAll('a[href^="#"]:not(.not-anchor)').forEach(link => {
	link.addEventListener('click', function (event) {
		if (this.hash) {
			slideToElement(this.hash);
			event.preventDefault();
		}
	});
});

onDomReady(() => {
	let requiredInputs = document.querySelectorAll('input[required]');

	requiredInputs.forEach(function (input) {
		let id = input.id;
		if (id) {
			let label = document.querySelector('label[for="' + id + '"]');
			if (label) {
				label.innerHTML += ' <span style="color: #ff0066;">*</span>';
			}
		}
	});

	document.querySelectorAll('input[type=password]').forEach(el => {
		el.parentElement.style.position = 'relative';
		el.insertAdjacentHTML(
			'afterend',
			'<span class="input-password-eye"></span>',
		);
	});

	const inputPasswordEye = document.querySelectorAll('.input-password-eye');
	inputPasswordEye.forEach(el => {
		el.addEventListener('click', e => {
			const input = e.target.previousElementSibling;
			if (input.type === 'password') {
				input.type = 'text';
			} else {
				input.type = 'password';
			}
		});
	});

	// scroll to top button
	const scrollToTopBtn = document.querySelector('.scroll-to-top');
	if (scrollToTopBtn) {
		scrollToTopBtn.addEventListener('click', () => {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		});
	}
});
